export enum ScreenAlertType {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
}

export type ScreenAlertContextState = {
  type: ScreenAlertType | null;
  message: string;
  isOpen: boolean;
};
